import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { unwrapResponse } from '../http/unwrap-response';
import { ResponseObj } from '../models/response.model';
import {
  ApproveResult,
  AuditEvent,
  QueueItem,
  QueueState,
  TransactionDetail,
} from '../models/transaction.model';

@Injectable({ providedIn: 'root' })
export class ApprovalService {
  private readonly baseUrl = `${environment.apiBaseUrl}/outward-approval`;

  constructor(private readonly http: HttpClient) {}

  getQueue(state: QueueState = 'PENDING_APPROVAL', limit = 50): Observable<QueueItem[]> {
    const params = new HttpParams().set('state', state).set('limit', limit);
    return this.http
      .get<ResponseObj<QueueItem[]>>(`${this.baseUrl}/queue`, { params })
      .pipe(unwrapResponse());
  }

  getTransaction(controlReference: string): Observable<TransactionDetail> {
    return this.http
      .get<ResponseObj<TransactionDetail>>(`${this.baseUrl}/transactions/${controlReference}`)
      .pipe(unwrapResponse());
  }

  getAuditHistory(controlReference: string): Observable<AuditEvent[]> {
    return this.http
      .get<ResponseObj<AuditEvent[]>>(
        `${this.baseUrl}/transactions/${controlReference}/audit`,
      )
      .pipe(unwrapResponse());
  }

  approve(controlReference: string): Observable<ApproveResult> {
    return this.http
      .post<ResponseObj<ApproveResult>>(
        `${this.baseUrl}/transactions/${controlReference}/approve`,
        {},
      )
      .pipe(unwrapResponse());
  }

  reject(controlReference: string, rejectionReason: string): Observable<string> {
    return this.http
      .post<ResponseObj<string>>(`${this.baseUrl}/transactions/${controlReference}/reject`, {
        rejectionReason,
      })
      .pipe(unwrapResponse());
  }
}
